import React, { useEffect, useState } from 'react';
import { Box, List, Typography } from '@mui/material';
import { useAppSelector } from '../hooks';
import { TOrderFeedback } from '../types';
import api from '../api';
import RestaurantReviewItem from '../components/RestaurantReviewItem';

const ReviewsScreen: React.FC = () => {
    const restaurantInfo = useAppSelector(state => state.restaurant.info);
    const [reviews, setReviews] = useState<TOrderFeedback[]>([])

    useEffect(() => {
        api.getRestaurantReviews().then(data => {
            setReviews(data)
        })
    }, [])

    return <Box sx={{ p: '12px 24px 24px 12px', height: 'calc(100vh - 112px)' }}>
     <Typography variant="subtitle1" color={'inherit'}>{restaurantInfo?.name}</Typography>
     <List>
        <section id='order-items'>
            {reviews.map((review) =>
            <Box pb={'20px'}>
            <RestaurantReviewItem item={review}></RestaurantReviewItem>
            </Box>
            )}</section>
  </List>
  </Box>
}
export default ReviewsScreen;